@file:OptIn(InternalResourceApi::class)

package top.features.user_management.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/top.features.user_management.generated.resources/"

@delegate:ResourceContentHash(1_295_460_852)
internal val Res.drawable.img_empty_moderators: DrawableResource by lazy {
      DrawableResource("drawable:img_empty_moderators", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_empty_moderators.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("img_empty_moderators", Res.drawable.img_empty_moderators)
}
